import React, { useState } from 'react';
import TabComponent from '../../components/TabComponent';
import ExpenseIndex from './Expense';
// import DailyTransactionsIndex from './DailyTransactions';
import OrganizationTransactionsIndex from './OrganizationTransactions';
import SuspenseTransactionsIndex from './SuspenseTransactions';
import BillingIndex from './Billing';
import BillingTransactionsIndex from './BillingTransactions';

export default function TransactionsIndex() {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const tabOptions = [
    {
      to: '',
      label: 'Expense',
      index: 0,
    },
    // {
    //   to: '',
    //   label: 'Daily Transaction',
    //   index: 1,
    // },
    {
      to: '',
      label: 'Organization Transactions',
      index: 1,
    },
    {
      to: '',
      label: 'Suspense Expenses',
      index: 2,
    },
    {
      to: '',
      label: 'Billing',
      index: 3,
    },
    {
      to: '',
      label: 'Billing Transactions',
      index: 4,
    },
  ];

  return (
    <div className="transactions__page">
      <h3>Transactions</h3>
      <div className="">
        <TabComponent
          taboptions={tabOptions}
          selectedTab={selectedIndex}
          setSelectedTab={setSelectedIndex}
        />
      </div>
      <div className="main__container">
        {/* {selectedIndex === 1 && <DailyTransactionsIndex />} */}
        {selectedIndex === 0 && <ExpenseIndex />}
        {selectedIndex === 1 && <OrganizationTransactionsIndex />}
        {selectedIndex === 2 && <SuspenseTransactionsIndex />}
        {selectedIndex === 3 && <BillingIndex />}
        {selectedIndex === 4 && <BillingTransactionsIndex />}
      </div>
    </div>
  );
}
